import React from "react";
import { Col, Divider } from "antd";

import config from "../../../../config";
import ExternalLink from "../../../app/generic/externalLink";

const Pricelists = () => (
  <Col span={8}>
    <Divider />
    <ExternalLink
      id="contracts.contract.pricelist.ecd"
      href={config.PRICELIST_ECD_DOCUMENT_URL}
      defaultMessage="aktuální všeobecný ceník produktů ECD"
    />
    {/* <br />
    <ExternalLink
      id="contracts.contract.pricelist.eci"
      href={config.PRICELIST_ECI_DOCUMENT_URL}
      defaultMessage="aktuální všeobecný ceník produktů ECI"
    /> */}
  </Col>
);

export default Pricelists;
